// extracted by mini-css-extract-plugin
export default {"indicator-card":"IndicatorCard_indicator-card__p5nv-","up":"IndicatorCard_up__H4m4v","down":"IndicatorCard_down__rGWRZ","stable":"IndicatorCard_stable__ABzQI"};